import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  filter(event) {
    const selectedProject = event.target.value
    const allProjects = this.containerTarget.querySelectorAll('[data-project]')

    allProjects.forEach(projectSection => {
      const project = projectSection.dataset.project

      if (selectedProject === '' || project === selectedProject) {
        projectSection.style.display = 'block'
      } else {
        projectSection.style.display = 'none'
      }
    })
  }
}